import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LayoutDefault from './layout/LayoutDefault';
import Index from './pages/Index';
import Success from './pages/Success';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LayoutDefault>
        <Router>
          <Switch>
            <Route path='/success' exact>
              <Success />
            </Route>
            <Route path='/:id' exact>
              <Index />
            </Route>
          </Switch>
        </Router>
      </LayoutDefault>
    </QueryClientProvider>
  );
}

export default App;
